import { Layout } from '@/data/types/Layout';

export const getRedirectSessionPage = (): Layout => ({
	name: 'SingleLayout',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'SessionError', id: 'session-error' }],
		second: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
